/* eslint-disable no-unused-vars */
import React, { createContext, useState, useContext, useEffect } from "react";
import { createEOBusinessProfile } from "../firebaseFunctions/createEOBusinessProfile/createEOBusinessProfile"; // Import the Firebase f
import { User } from "lucide-react";

const BusinessProfileContext = createContext();

// Create the provider
export const BusinessProfileProvider = ({ children }) => {
  const [businessProfileData, setBusinessProfileData] = useState(() => {
    // Try to get existing data from localStorage
    const savedData = localStorage.getItem("businessProfileData");
    return savedData
      ? JSON.parse(savedData)
      : {
          UserID: "",
          fullName: "",
          businessName: "",
          organizerName: "",
          planType: "",
          approvedTermsOfService: "true",
          stripeAccountConnected: false,
          EOProfileID: "false",
          contactNumber: null,
        };
  });

  // Add useEffect to save to localStorage whenever businessProfileData changes
  useEffect(() => {
    localStorage.setItem(
      "businessProfileData",
      JSON.stringify(businessProfileData)
    );
  }, [businessProfileData]);

  const updateBusinessProfile = (newData) => {
    setBusinessProfileData((prevData) => ({ ...prevData, ...newData }));
    console.log("while creating user", businessProfileData);
  };

  // Function to submit profile data to Firebase
  const submitBusinessProfile = async (profileData = null) => {
    try {
      const dataToSubmit = profileData || businessProfileData;
      const result = await createEOBusinessProfile(dataToSubmit);

      console.log("Profile saved successfully", dataToSubmit, result);
      return result;
    } catch (error) {
      console.error("Error saving profile:", error);
      return { success: false, message: error.message };
    }
  };

  return (
    <BusinessProfileContext.Provider
      value={{
        businessProfileData,
        updateBusinessProfile,
        submitBusinessProfile,
      }}
    >
      {children}
    </BusinessProfileContext.Provider>
  );
};

// Custom hook to use the ProfileContext
export const useBusinessProfile = () => {
  return useContext(BusinessProfileContext);
};
